"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mover = void 0;

var Utils_1 = require("../../Utils");

var Enums_1 = require("../../Enums");

var Mover = /*#__PURE__*/function () {
  function Mover(container, particle) {
    _classCallCheck(this, Mover);

    this.container = container;
    this.particle = particle;
  }

  _createClass(Mover, [{
    key: "move",
    value: function move(delta) {
      var particle = this.particle;
      particle.bubble.inRange = false;
      particle.links = [];

      var _iterator = _createForOfIteratorHelper(this.container.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              plugin = _step$value[1];

          if (particle.destroyed) {
            break;
          }

          if (plugin.particleUpdate) {
            plugin.particleUpdate(particle, delta);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (particle.destroyed) {
        return;
      }

      this.moveParticle(delta);
      this.moveParallax();
    }
  }, {
    key: "moveParticle",
    value: function moveParticle(delta) {
      var _a, _b, _c;

      var particle = this.particle;
      var particlesOptions = particle.options;

      if (!particlesOptions.move.enable) {
        return;
      }

      var container = this.container;
      var slowFactor = this.getProximitySpeedFactor();
      var baseSpeed = ((_a = particle.moveSpeed) !== null && _a !== void 0 ? _a : Utils_1.NumberUtils.getRangeValue(particle.options.move.speed) * container.retina.pixelRatio) * container.retina.reduceFactor;
      var maxSize = Utils_1.NumberUtils.getRangeMax(particle.options.size.value) * container.retina.pixelRatio;
      var sizeFactor = particlesOptions.move.size ? particle.getRadius() / maxSize : 1;
      var moveSpeed = baseSpeed / 2 * sizeFactor * slowFactor * delta.factor;
      var moveDrift = (_b = particle.moveDrift) !== null && _b !== void 0 ? _b : Utils_1.NumberUtils.getRangeValue(particle.options.move.drift) * container.retina.pixelRatio;
      this.applyPath(delta);
      var gravityOptions = particlesOptions.move.gravity;
      var gravityFactor = gravityOptions.enable && gravityOptions.inverse ? -1 : 1;

      if (gravityOptions.enable) {
        particle.velocity.y += gravityFactor * (gravityOptions.acceleration * delta.factor) / (60 * moveSpeed);
      }

      if (moveSpeed) {
        particle.velocity.x += moveDrift * delta.factor / (60 * moveSpeed);
      }

      particle.velocity.multTo(1 - particle.options.move.decay);
      var velocity = particle.velocity.mult(moveSpeed);
      var maxSpeed = (_c = particle.maxSpeed) !== null && _c !== void 0 ? _c : container.retina.maxSpeed;

      if (gravityOptions.enable && (!gravityOptions.inverse && velocity.y >= 0 && velocity.y >= maxSpeed || gravityOptions.inverse && velocity.y <= 0 && velocity.y <= -maxSpeed) && gravityOptions.maxSpeed > 0) {
        velocity.y = gravityFactor * maxSpeed;

        if (moveSpeed) {
          particle.velocity.y = velocity.y / moveSpeed;
        }
      }

      particle.position.addTo(velocity);

      if (particlesOptions.move.vibrate) {
        particle.position.x += Math.sin(particle.position.x * Math.cos(particle.position.y));
        particle.position.y += Math.cos(particle.position.y * Math.sin(particle.position.x));
      }

      var initialPosition = particle.initialPosition;
      var initialDistance = Utils_1.NumberUtils.getDistance(initialPosition, particle.position);

      if (particle.maxDistance) {
        if (initialDistance >= particle.maxDistance && !particle.misplaced) {
          particle.misplaced = initialDistance > particle.maxDistance;
          particle.velocity.x = particle.velocity.y / 2 - particle.velocity.x;
          particle.velocity.y = particle.velocity.x / 2 - particle.velocity.y;
        } else if (initialDistance < particle.maxDistance && particle.misplaced) {
          particle.misplaced = false;
        } else if (particle.misplaced) {
          if (particle.position.x < initialPosition.x && particle.velocity.x < 0 || particle.position.x > initialPosition.x && particle.velocity.x > 0) {
            particle.velocity.x *= -Math.random();
          }

          if (particle.position.y < initialPosition.y && particle.velocity.y < 0 || particle.position.y > initialPosition.y && particle.velocity.y > 0) {
            particle.velocity.y *= -Math.random();
          }
        }
      }
    }
  }, {
    key: "applyPath",
    value: function applyPath(delta) {
      var particle = this.particle;
      var particlesOptions = particle.options;
      var pathOptions = particlesOptions.move.path;
      var pathEnabled = pathOptions.enable;

      if (!pathEnabled) {
        return;
      }

      var container = this.container;

      if (particle.lastPathTime <= particle.pathDelay) {
        particle.lastPathTime += delta.value;
        return;
      }

      var generator = container.pathGenerator;

      if (pathOptions.generator) {
        var customGenerator = Utils_1.Plugins.getPathGenerator(pathOptions.generator);

        if (customGenerator) {
          generator = customGenerator;
        }
      }

      var path = generator.generate(particle);
      particle.velocity.addTo(path);

      if (pathOptions.clamp) {
        particle.velocity.x = Utils_1.NumberUtils.clamp(particle.velocity.x, -1, 1);
        particle.velocity.y = Utils_1.NumberUtils.clamp(particle.velocity.y, -1, 1);
      }

      particle.lastPathTime -= particle.pathDelay;
    }
  }, {
    key: "moveParallax",
    value: function moveParallax() {
      var container = this.container;
      var options = container.actualOptions;

      if (Utils_1.Utils.isSsr() || !options.interactivity.events.onHover.parallax.enable) {
        return;
      }

      var particle = this.particle;
      var parallaxForce = options.interactivity.events.onHover.parallax.force;
      var mousePos = container.interactivity.mouse.position;

      if (!mousePos) {
        return;
      }

      var canvasCenter = {
        x: container.canvas.size.width / 2,
        y: container.canvas.size.height / 2
      };
      var parallaxSmooth = options.interactivity.events.onHover.parallax.smooth;
      var factor = particle.getRadius() / parallaxForce;
      var tmp = {
        x: (mousePos.x - canvasCenter.x) * factor,
        y: (mousePos.y - canvasCenter.y) * factor
      };
      particle.offset.x += (tmp.x - particle.offset.x) / parallaxSmooth;
      particle.offset.y += (tmp.y - particle.offset.y) / parallaxSmooth;
    }
  }, {
    key: "getProximitySpeedFactor",
    value: function getProximitySpeedFactor() {
      var container = this.container;
      var options = container.actualOptions;
      var active = Utils_1.Utils.isInArray(Enums_1.HoverMode.slow, options.interactivity.events.onHover.mode);

      if (!active) {
        return 1;
      }

      var mousePos = this.container.interactivity.mouse.position;

      if (!mousePos) {
        return 1;
      }

      var particlePos = this.particle.getPosition();
      var dist = Utils_1.NumberUtils.getDistance(mousePos, particlePos);
      var radius = container.retina.slowModeRadius;

      if (dist > radius) {
        return 1;
      }

      var proximityFactor = dist / radius || 0;
      var slowFactor = options.interactivity.modes.slow.factor;
      return proximityFactor / slowFactor;
    }
  }]);

  return Mover;
}();

exports.Mover = Mover;